import axios from "axios";

export const getCurrentUser = async ({ token, username, baseUrl }) => {
  const resp = await axios.get(
    `${baseUrl}/webservice/rest/server.php?wstoken=${token}&wsfunction=core_user_get_users_by_field&field=username&values[0]=${username}&moodlewsrestformat=json`
  );
  if (resp.data.errorcode) {
    throw new Error(resp.data.message || resp.data.errorcode);
  }
  const user = resp.data[0];
  if (!user) {
    throw new Error("User not found");
  }
  return { ...user, token };
};

/* auth_userkey_request_login_url */

const login = async ({ username, password, baseUrl }) => {
  const respAuth = await axios.get(
    `${baseUrl}/login/token.php?username=${username}&password=${password}&service=moodle_mobile_app`
  );
  const data = respAuth.data;
  if (data.error) {
    throw new Error(data.error);
  }
  const { token } = data;
  return { data, token };
};

export const requestAutoLogin = async ({ email, baseUrl, tipddytoken }) => {
  try {
    const { data } = await axios.get(
      `${baseUrl}/webservice/rest/server.php?wstoken=${tipddytoken}&moodlewsrestformat=json&wsfunction=auth_userkey_tipddy_request_login_url&user[email]=${encodeURIComponent(email)}`
    );
    let key = data && data.loginurl.split("=")[1];
    return {key,data};
  } catch (e) {
    throw new Error(e);
  }
};

/* export const requestAutoLogout = () => {
  let url = `${baseURL}auth/userkey/logout.php?return=${API.dev}`

} */

  export const loginMoodle = async (payload) => {
    let { baseUrl, credentials } = payload;
    let { username, password } = credentials;
    console.log({ baseUrl });
    try {
      const { token } = await login({ username, password, baseUrl });
      const user = await getCurrentUser({ token, username, baseUrl });
      // console.log({ user });
      localStorage.setItem("token", token);
      localStorage.setItem("username", username);
      return { ...user, token };
    } catch (e) {
      throw new Error(e);
    }
  };

export const resetPasword = async (args) => {
  console.log({ args });
  try {
    const { data } = await axios.post(
      "https://par.tuclase.cl/tipddy/admin/iapp/services/restore-password.php/user/changepasswordforce",
      { ...args },
      {
        headers: {
          "Content-type": "application/json",
        },
      }
    );
    return data;
  } catch (e) {
    console.log(e);
    throw new Error(e);
  }
};

export const getTokenForLoggedInUser = async ({ baseUrl }) => {
  const resp = await axios.get(
    `${baseUrl}/webservice/rest/server.php?wsfunction=core_auth_get_token_for_logged_in_user&service=moodle_mobile_app&moodlewsrestformat=json`,
    { withCredentials: true }
  );
  if (resp.data.errorcode) {
    throw new Error(resp.data.message || resp.data.errorcode);
  }
  if (!resp.data.token) {
    throw new Error("Token not returned by Moodle");
  }
  return resp.data;
};

export const exchangeHandoffForToken = async ({ baseUrl, handoff }) => {
  const resp = await axios.get(
    `${baseUrl}/auth/userkey_tipddy/exchange.php?handoff=${encodeURIComponent(handoff)}`,
    { withCredentials: true }
  );
  if (resp.data.error) {
    throw new Error(resp.data.error);
  }
  if (!resp.data.token) {
    throw new Error("Token not returned by exchange endpoint");
  }
  return resp.data;
};

export const authMiddleware = async ({ token, username }) => {
  try {
    const user = await getCurrentUser({ token, username });
    if (user.errorcode) {
      localStorage.setItem("username", username);
      localStorage.setItem("token", token);
      return user;
    }
    localStorage.setItem("token", token);
    localStorage.setItem("username", username);
    return { ...user, token };
  } catch (err) {
    console.log(err);
    throw new Error(err.message);
  }
};
